import { Avatar, ButtonBase, Stack, Typography } from '@mui/material'
import { SxProps } from '@mui/system'
import { Icons } from 'utoniq-ui'

import { Maybe } from '@/clients/utoniq-core/schema'
import { useTranslation } from '@/core'
import { Cell, Organism } from '@/core/architecture'

export type ItemProps = { id?: Maybe<string>; thumbnail?: { uri?: string } }

export type ItemImageProps = {
  onClick: () => void
  item: ItemProps
  selected: ItemProps | null
  defaultValue: ItemProps['id']
  sx?: SxProps
}

export const ItemImage: Organism<ItemImageProps> = ({
  onClick,
  item,
  selected,
  sx,
  defaultValue,
}) => {
  const { t } = useTranslation('customProfileEditWallPaper')
  return (
    <ButtonBase sx={{ position: 'relative', width: '100%' }} onClick={onClick}>
      <Avatar
        variant="square"
        src={item.thumbnail?.uri ?? ''}
        sx={{
          minHeight: 70,
          width: '100%',
          ...sx,
        }}
      />
      {selected?.id === item.id && item.id !== defaultValue && (
        <>
          <Icons.Selected
            fontSize="medium"
            sx={{
              color: 'primary.main',
              position: 'absolute',
              top: -4,
              right: -4,
              zIndex: 1,
            }}
          />
          <OverlayCell
            sx={{ bgcolor: 'grey.900', opacity: 0.8 }}
            text={t('choosing')}
          />
        </>
      )}
      {item.id === defaultValue && (
        <OverlayCell
          sx={{ bgcolor: 'grey.50', opacity: 0.8 }}
          text={t('setup')}
        />
      )}
    </ButtonBase>
  )
}

type OverlayCellProps = {
  text: string
  sx?: SxProps
}

const OverlayCell: Cell<OverlayCellProps> = ({ sx, text }) => (
  <Stack
    flex={1}
    direction="row"
    justifyContent="center"
    sx={{
      position: 'absolute',
      inset: 0,
      ...sx,
    }}
  >
    <Stack justifyContent="center">
      <Typography variant="subtitle1">{text}</Typography>
    </Stack>
  </Stack>
)
